import { cloneAuthoring } from "./authoring-json.mjs";
import { editableSubject, subjectDefinition, withSubjectTokenDefault } from "./authoring-subject.mjs";

export function ideaGenerators(document, context) {
  return document.nodes.filter(node => {
    const definition = subjectDefinition(node, context);
    return definition?.parallelGroup === "ideas" && definition.parallelRole === "generator";
  });
}

export function ideaGeneratorAddIssue(source, context) {
  if (!editableSubject(source, context) || !context.graphEdit || !context.parallelIdeas) return "Добавление генераторов недоступно для этой версии решения. Требуется черновик с поддержкой параллельных генераторов.";
  if (ideaGenerators(source, context).length >= context.parallelIdeas.maxGenerators || source.nodes.length >= 50) return "Достигнут предел генераторов идей или шагов решения";
  return "";
}

export function addIdeaGenerator(source, context, blockID, copyID = "") {
  const issue = ideaGeneratorAddIssue(source, context);
  if (issue) throw new Error(issue);
  const original = source.nodes.find(node => node.id === copyID);
  const definition = original ? subjectDefinition(original, context) : context.blockDefinitions?.[blockID];
  if (definition?.parallelGroup !== "ideas" || definition.parallelRole !== "generator" || definition.copyable === false) throw new Error("Этот этап нельзя добавить как генератор идей");
  const generators = ideaGenerators(source, context);
  const document = cloneAuthoring(source), { rootNodeId, joinNodeId, joinPort } = context.parallelIdeas;
  const join = document.nodes.find(node => node.id === joinNodeId);
  if (!join || !document.nodes.some(node => node.id === rootNodeId)) throw new Error("Не найдены обязательные этапы генерации идей");
  let index = 1; while (document.nodes.some(node => node.id === `idea_variant_${index}`)) index++;
  const node = cloneAuthoring(original || definition.nodeTemplate);
  let labelIndex=1; while (generators.some(item=>item.name===`Идеи маршрутов · генератор ${labelIndex}` || item.id===`idea_generator_${labelIndex}`)) labelIndex++;
  node.id = `idea_variant_${index}`; node.name = `Идеи маршрутов · генератор ${labelIndex}`;
  node.inputBindings = { [rootNodeId]: { nodeId: rootNodeId } }; delete node.dependsOn;
  document.nodes.splice(document.nodes.indexOf(join), 0, withSubjectTokenDefault(node, context));
  join.inputBindings = { [joinPort]: { nodeIds: [...generators.map(node => node.id), node.id] } };
  return { document, id: node.id };
}

export function removeIdeaGenerator(source, context, id) {
  const generators = ideaGenerators(source, context);
  if (!editableSubject(source, context) || !context.graphEdit || !context.parallelIdeas || !generators.some(node => node.id === id)) throw new Error("Удалять можно только генераторы идей");
  if (generators.length <= 1) throw new Error("Оставьте хотя бы один генератор идей");
  const document = cloneAuthoring(source), { joinNodeId, joinPort } = context.parallelIdeas;
  document.nodes = document.nodes.filter(node => node.id !== id);
  const join = document.nodes.find(node => node.id === joinNodeId);
  if (!join) throw new Error("Не найден этап отбора идей");
  join.inputBindings = { [joinPort]: { nodeIds: generators.filter(node => node.id !== id).map(node => node.id) } };
  return document;
}
